import "./EPCCertificate.module.css";
import Header from "@/reusable_sections/Header";
import RequestEpcCertificate from "./sections/RequestEpcCertificate";
import EpcHoeWerktHet from "./sections/EpcHoeWerktHet";
import FreeQuoteSection from "./sections/FreeQuoteSection";
import VeelgesteldeVragen from "./sections/VeelgesteldeVragen";
import Footer from "@/reusable_sections/Footer";
export default function EPCCertificatePage() {
  return <div>
      <Header />
      <RequestEpcCertificate />
      <EpcHoeWerktHet />
      <FreeQuoteSection />
      <VeelgesteldeVragen />
      <Footer />
    </div>;
}